import { useRoomContext } from '@livekit/components-react';
import { useEffect } from 'react';

const useDisconnectOnUnload = () => {
	const room = useRoomContext();

	useEffect(() => {
		const disconnect = () => room.disconnect();

		window.addEventListener('pagehide', disconnect);
		window.addEventListener('beforeunload', disconnect);

		return () => {
			window.removeEventListener('pagehide', disconnect);
			window.removeEventListener('beforeunload', disconnect);
		};
	}, [room]);
};

export default useDisconnectOnUnload;
